(() => {
  "use strict";
  const n = {
    query:
      "\n      mutation getShieldConfiguration($shopDomain: String!) {\n        getShieldConfiguration(shopDomain: $shopDomain) {\n          success\n          errors {\n            message\n          }\n          result\n        }\n      }\n    ",
    resultKey: "getShieldConfiguration",
  };
  async function t(n) {
    try {
      const t = await fetch("https://ship.gadget.app/api/graphql", {
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          query: n.query,
          variables: { shopDomain: String(window.location.href) },
        }),
        method: "POST",
      });
      return (await t.json()).data[n.resultKey].result;
    } catch (t) {
      throw (console.error(`Error fetching ${n.resultKey}:`, t), t);
    }
  }
  async function e() {
    return (await fetch("/cart.js")).json();
  }
  async function i({ cartItems: n }) {
    var t, e, i;
    const o = await c();
    if (o && o.length > 0)
      return (async function ({ cartItems: n }) {
        const t = await (async function () {
          var n, t;
          return null !==
            (t =
              null === (n = (await s())[0]) || void 0 === n
                ? void 0
                : n.productId) && void 0 !== t
            ? t
            : "";
        })();
        if (!t) return [];
        const e = n.filter((n) => {
            const e = Number(n.line_price) || 0;
            return n.product_id !== t && e > 0;
          }),
          i = await (async function ({ cartItems: n }) {
            var t, e, i;
            const o = { no_subscription: [] },
              a = await c(),
              r = await l();
            for (var s = 0; s < n.length; s++) {
              const r = n[s];
              let l =
                null ===
                  (t = a.find(
                    (n) => n.shopSellingPlanId === r.selling_plan_id
                  )) || void 0 === t
                  ? void 0
                  : t.shieldSellingPlanId;
              l
                ? (o[l] || (o[l] = []),
                  o[l].push(null !== (i = r.key) && void 0 !== i ? i : ""))
                : o.no_subscription.push(
                    null !== (e = r.key) && void 0 !== e ? e : ""
                  );
            }
            Object.keys(o).forEach((n) => {
              0 === o[n].length && delete o[n];
            });
            const d = await Promise.all(
              Object.entries(o).map(async ([t, e]) => {
                const i = n.filter((n) => {
                    var t;
                    return e.includes(
                      null !== (t = n.key) && void 0 !== t ? t : ""
                    );
                  }),
                  o = i.reduce((n, t) => {
                    var e;
                    return (
                      n +
                      (null !== (e = t.line_price) && void 0 !== e ? e : 0) /
                        100
                    );
                  }, 0);
                return {
                  sellingPlanId: t,
                  protectionPrice: await g({
                    protectionRules: r,
                    totalPrice: o,
                  }),
                };
              })
            );
            return d;
          })({ cartItems: e }),
          o = await (async function ({ groupedCartLineItemsBySellingPlan: n }) {
            const t = await s(),
              e = n.map(async (n) => {
                const e = n.protectionPrice,
                  i = await p(e),
                  o = t.find((n) => n.price === i);
                if ("no_subscription" === n.sellingPlanId)
                  return {
                    price: null == o ? void 0 : o.price,
                    productId: null == o ? void 0 : o.productId,
                    variantId: null == o ? void 0 : o.id,
                  };
                const a = n.sellingPlanId;
                return {
                  price: null == o ? void 0 : o.price,
                  productId: null == o ? void 0 : o.productId,
                  variantId: null == o ? void 0 : o.id,
                  selling_plan: a,
                };
              });
            return (await Promise.all(e)).filter((n) => null !== n);
          })({ groupedCartLineItemsBySellingPlan: i });
        return o;
      })({ cartItems: n });
    const a = await l(),
      r = (function ({ cartItems: n }) {
        return n.reduce((n, t) => n + t.line_price / 100, 0);
      })({ cartItems: n }),
      d = await g({ protectionRules: a, totalPrice: r }),
      u = await p(d),
      h = (await s()).find((n) => n.price === u);
    return [
      {
        price: u,
        variantId:
          null !== (t = null == h ? void 0 : h.id) && void 0 !== t ? t : "",
        productId:
          null !== (e = null == h ? void 0 : h.productId) && void 0 !== e
            ? e
            : "",
        selling_plan:
          null !== (i = null == h ? void 0 : h.sellingPlan) && void 0 !== i
            ? i
            : "",
      },
    ];
  }
  async function o({ type: e }) {
    const i = {
      customization: "com.shield:customization",
      protection_rules: "com.shield:protection_rules",
      shield_variants: "com.shield:shield_variants",
      selling_plan_mapping: "com.shield:selling_plan_mapping",
    };
    try {
      const o = localStorage.getItem(i[e]);
      if (o) {
        const { timestamp: n, data: t } = JSON.parse(o);
        if (Date.now() - n < 36e5) return t;
      }
      return (
        await (async function () {
          try {
            const e = await t(n),
              o = {
                customization: e.shield_customization,
                protection_rules: e.protection_rules,
                shield_variants: e.shield_variants,
                selling_plan_mapping: e.selling_plan_mapping,
              };
            return (
              Object.entries(o).forEach(([n, t]) => {
                localStorage.setItem(
                  i[n],
                  JSON.stringify({ timestamp: Date.now(), data: t })
                );
              }),
              o
            );
          } catch (n) {
            throw (console.error("Error fetching Shield configuration:", n), n);
          }
        })()
      )[e];
    } catch (n) {
      console.log("error fetching shield data", n);
      const t = localStorage.getItem(i[e]);
      if (t) return JSON.parse(t).data;
      throw n;
    }
  }
  async function a() {
    const n = await e(),
      t = await s(),
      i = n.items.filter((n) =>
        t.some((t) => String(n.product_id) === String(t.productId))
      );
    if (i.length > 0) {
      const n = i.map((n) => n.key);
      await (async function ({ variantKeys: n, quantity: t }) {
        const e = n.reduce((n, e) => ((n[e] = t), n), {});
        Object.getOwnPropertyNames(e).length &&
          (await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({ updates: e }),
          })
            .then((n) => n.json())
            .catch((n) => {
              console.error("Error:", n);
            }));
      })({ variantKeys: n, quantity: 0 });
    }
  }
  async function r() {
    return o({ type: "customization" });
  }
  async function l() {
    return o({ type: "protection_rules" });
  }
  async function s() {
    return o({ type: "shield_variants" });
  }
  async function c() {
    return o({ type: "selling_plan_mapping" });
  }
  function d({ isLoading: n }) {
    n
      ? ((document.getElementById("text-loader").style.display = "block"),
        (document.getElementById("loader").style.display = "block"),
        (document.getElementById("toggle-switch").style.display = "none"))
      : ((document.getElementById("text-loader").style.display = "none"),
        (document.getElementById("loader").style.display = "none"),
        (document.getElementById("toggle-switch").style.display = "block"));
  }
  function u({ price: n }) {
    const t = "$" + n.toFixed(2),
      e = document.getElementById("shield-price");
    e && (e.innerHTML = t);
  }
  async function p(n) {
    const t = await l(),
      e = t[0].min_protection_price,
      i = t[0].max_protection_price;
    let o = Math.round(4 * n) / 4;
    return (
      e && o < e && (o = Math.round(4 * e) / 4),
      i && o > i && (o = Math.round(4 * i) / 4),
      o < 0.25 && (o = 0.25),
      o > 25 && (o = 25),
      o.toFixed(2)
    );
  }
  async function g({ protectionRules: n, totalPrice: t }) {
    let e = 0,
      i = !1,
      o = !1;
    for (const a of n) {
      const n = "fixed" === a.type,
        r = "variable" === a.type;
      if (n && a.fixed_amount) {
        if (i) throw new Error("More than one fixed protection rule found");
        (i = !0), (e += a.fixed_amount);
      }
      if (r && a.percent_amount) {
        if (o) throw new Error("More than one variable protection rule found");
        (o = !0), (e += (a.percent_amount / 100) * t);
      }
    }
    return e;
  }
  function h({ cart: n }) {
    return n.items.map((n) => {
      var t, e, i, o;
      return {
        id: String(n.id),
        key: n.key,
        quantity: n.quantity,
        variant_id: String(n.variant_id),
        product_id: String(n.product_id),
        line_price: n.line_price,
        selling_plan_id:
          null !==
            (o =
              null ===
                (i =
                  null ===
                    (e =
                      null === (t = n.selling_plan_allocation) || void 0 === t
                        ? void 0
                        : t.selling_plan) || void 0 === e
                    ? void 0
                    : e.id) || void 0 === i
                ? void 0
                : i.toString()) && void 0 !== o
            ? o
            : void 0,
      };
    });
  }
  async function m() {
    const n = await e();
    u({
      price: (await i({ cartItems: h({ cart: n }) })).reduce(
        (n, t) => n + Number(t.price),
        0
      ),
    });
  }
  function f() {
    window.localStorage.setItem("com.shield:cart_enabled", "true");
  }
  function y() {
    return {
      pluginEnabled: window.shieldMetafields.pluginEnabled,
      defaultEnabled: window.shieldMetafields.defaultEnabled,
    };
  }
  async function w(n) {
    d({ isLoading: !0 });
    const t = window.localStorage.getItem("com.shield:cart_enabled")
        ? "true" === window.localStorage.getItem("com.shield:cart_enabled")
        : null,
      o = n.defaultEnabled;
    let a = !1;
    const l = await e();
    if (!l) return;
    const s = h({ cart: l }),
      c = await i({ cartItems: s }),
      p = c.reduce((n, t) => n + Number(t.price), 0);
    c.length > 0 &&
      ((async function ({ customization: n }) {
        var t, e, i, o;
        try {
          const a =
              null !== (t = null == n ? void 0 : n.title) && void 0 !== t
                ? t
                : "Shield Shipping Protection",
            r = document.getElementById("shield-title");
          r && (r.innerHTML = a);
          const l =
              null !== (e = null == n ? void 0 : n.subtitleHtml) && void 0 !== e
                ? e
                : "<p>If lost, stolen, or damaged, we replace</p>",
            s = document.getElementById("shield-subtitle");
          s && (s.innerHTML = l);
          const c =
              null !==
                (o =
                  null === (i = null == n ? void 0 : n.customThumbnail) ||
                  void 0 === i
                    ? void 0
                    : i.url) && void 0 !== o
                ? o
                : "https://www.shieldshippingprotection.com/shield-widget-logo.png",
            d = document.getElementsByClassName("shield-logo")[0];
          d && ((d.src = c), (d.style.display = "block"));
        } catch (n) {
          console.error("Error setting widget settings:", n),
            (function () {
              const n = document.getElementById("shield-title");
              n && (n.innerHTML = "Shield Shipping Protection");
              const t = document.getElementById("shield-subtitle");
              t && (t.innerHTML = "<p>If lost, stolen, or damaged, we replace");
              const e = document.getElementsByClassName("shield-logo")[0];
              e &&
                ((e.src =
                  "https://www.shieldshippingprotection.com/shield-widget-logo.png"),
                (e.style.display = "block"));
            })();
        }
      })({ customization: await r() }),
      u({ price: p })),
      d({ isLoading: !1 }),
      !1 !== t && o && f();
  }
  async function b() {
    const n = localStorage.getItem("com.shield:checkoutButtonSelector");
    function t() {
      const t = document.querySelector(
        null != n ? n : ".Button.Button--primary"
      );
      if (!t) return;
      let o = !1;
      t.addEventListener(
        "click",
        async function n(r) {
          if (!o) {
            r.stopImmediatePropagation(), r.preventDefault(), (o = !0);
            try {
              await (async function () {
                const n = window.localStorage.getItem(
                    "com.shield:cart_enabled"
                  ),
                  t = await e();
                if (!t) return;
                const o = h({ cart: t }),
                  r = await i({ cartItems: o });
                await (async function ({
                  protectionEnabled: n,
                  protectionProductVariants: t,
                }) {
                  u({ price: t.reduce((n, t) => n + Number(t.price), 0) }),
                    n
                      ? (await a(),
                        await (async function (n) {
                          const t = n.map((n) => ({
                            quantity: n.quantity,
                            id: n.variantId,
                            selling_plan: n.selling_plan,
                          }));
                          if (t.length)
                            try {
                              await fetch("/cart/add.js", {
                                method: "POST",
                                headers: {
                                  "Content-Type": "application/json",
                                  "X-Requested-With": "XMLHttpRequest",
                                },
                                body: JSON.stringify({ items: t }),
                              });
                            } catch (n) {
                              console.error("Error:", n);
                            }
                        })(
                          t.map((n) => {
                            var t;
                            return {
                              quantity: 1,
                              variantId:
                                null !== (t = n.variantId) && void 0 !== t
                                  ? t
                                  : "",
                              selling_plan: n.selling_plan,
                            };
                          })
                        ))
                      : await a();
                })({
                  protectionEnabled: "true" === n,
                  protectionProductVariants: r,
                });
              })();
            } catch (n) {
              console.error("❌ Error handling checkout click:", n);
            } finally {
              if (
                ((o = !1),
                t.removeEventListener("click", n, !0),
                "a" === t.tagName.toLowerCase())
              ) {
                const n = t.href;
                n && (window.location.href = n);
              } else t.click();
              t.addEventListener("click", n, !0);
            }
          }
        },
        !0
      );
    }
    let o = null;
    const r = new MutationObserver((e, i) => {
        const a = null != n ? n : ".Button.Button--primary",
          r = document.querySelector(a);
        r !== o &&
          ((o = r),
          r
            ? (t(),
              i.disconnect(),
              i.observe(r, { attributes: !0, childList: !0, subtree: !0 }))
            : (i.disconnect(),
              i.observe(document.body, { childList: !0, subtree: !0 })));
      }),
      l = null != n ? n : ".Button.Button--primary",
      s = document.querySelector(l);
    s
      ? ((o = s),
        t(),
        r.observe(s, { attributes: !0, childList: !0, subtree: !0 }))
      : r.observe(document.body, { childList: !0, subtree: !0 });
  }
  let v = null;
  async function _({ metafields: n }) {
    await a(),
      await (async function () {
        return new Promise((n) => {
          const t = setInterval(() => {
            const e = document.querySelector("shield-widget");
            e &&
              (e.replaceChildren(),
              (e.innerHTML =
                '\n<div id="shield-container">\n    <div id="shield-container-left">\n        <img\n            loading="eager"\n            class="shield-logo"\n            id="logo"\n            src="https://shieldshippingprotection.com/shield-widget-logo.png"\n            width="24"\n            height="24"\n            alt="Shield Shipping Protection"\n            >\n            <div>\n            <div id="shield-container-title">\n                <span class="text-loader" id="text-loader"></span>\n\n                <div class="shield-primary" id="shield-title">\n                <span class="skeleton-box" style="width: 100%"></span>\n                </div>\n            </div>\n\n            <div id="shield-subtitle"></div>\n            </div>\n        </div>\n\n        <div id="shield-container-right">\n            <div class="switch-container">\n            <span class="loader" id="loader"></span>\n            <label class="switch" id="toggle-switch">\n                <input type="checkbox" id="cartToggle">\n                <span class="slider round"></span>\n            </label>\n            </div>\n            <div id="shield-price"></div>\n        </div>\n    </div>\n'),
              e.classList.add("shield-widget"),
              clearInterval(t),
              n());
          }, 500);
        });
      })(),
      (function () {
        const n = document.getElementById("cartToggle");
        if (!n) return void console.error("cartToggle element not found.");
        const t = localStorage.getItem("com.shield:cart_enabled");
        if (null === t) {
          const t = y();
          n.checked = t.defaultEnabled;
        } else n.checked = "true" === t;
        (n.onchange = () => {
          1 ==
          !("true" == window.localStorage.getItem("com.shield:cart_enabled"))
            ? f()
            : window.localStorage.setItem("com.shield:cart_enabled", "false");
        }),
          window.addEventListener("storage", (t) => {
            "com.shield:cart_enabled" === t.key &&
              (n.checked = "true" === t.newValue);
          });
      })(),
      b(),
      w(n),
      (async function () {
        (window.originXHRSend = XMLHttpRequest.prototype.send),
          (XMLHttpRequest.prototype.send = function (...n) {
            this.addEventListener("load", async () => {
              /\/cart\/(change|add|update)(?:\.js)?/.test(this.responseURL) &&
                (await m());
            }),
              window.originXHRSend.apply(this, n);
          });
        const n = window.fetch;
        window.fetch = function (...t) {
          return n.apply(this, t).then(async (n) => {
            const t = n.clone();
            return (
              /\/cart\/(change|add|update)(?:\.js)?/.test(t.url) && (await m()),
              n
            );
          });
        };
      })(),
      (function (n) {
        let t = !1;
        function e(n) {
          v && clearTimeout(v),
            (v = setTimeout(() => {
              _({ metafields: n }), (v = null);
            }, 100));
        }
        new MutationObserver((i) => {
          for (const o of i) {
            const i = document.querySelector("shield-widget");
            "attributes" === o.type &&
              "class" === o.attributeName &&
              (!i || i.hasChildNodes() || t || (e(n), (t = !0)));
          }
        }).observe(document.body, {
          attributes: !0,
          attributeFilter: ["class"],
          attributeOldValue: !0,
          childList: !0,
          subtree: !0,
        });
      })(n);
  }
  document.addEventListener("DOMContentLoaded", async () => {
    const e = y(),
      i = await (async function () {
        try {
          if (
            ["customization", "protectionRules", "shieldVariants"].every(
              (n) => {
                const t = localStorage.getItem(`com.shield:${n}`);
                if (!t) return !1;
                const { timestamp: e, data: i } = JSON.parse(t);
                return Date.now() - e < 36e5 && i;
              }
            )
          )
            return {
              customization: JSON.parse(
                localStorage.getItem("com.shield:customization") || ""
              ).data,
              protectionRules: JSON.parse(
                localStorage.getItem("com.shield:protection_rules") || ""
              ).data,
              shieldVariants: JSON.parse(
                localStorage.getItem("com.shield:shield_variants") || ""
              ).data,
              sellingPlanMapping: JSON.parse(
                localStorage.getItem("com.shield:selling_plan_mapping") || ""
              ).data,
            };
          const e = await t(n),
            i = {
              customization: e.shieldCustomization,
              protection_rules: e.protectionRules,
              shield_variants: e.shieldVariants,
              selling_plan_mapping: e.sellingPlanMapping,
            };
          return (
            Object.entries(i).forEach(([n, t]) => {
              localStorage.setItem(
                `com.shield:${n}`,
                JSON.stringify({ timestamp: Date.now(), data: t })
              );
            }),
            i
          );
        } catch (n) {
          throw (console.error("Error loading Shield data:", n), n);
        }
      })();
    console.log("Shield data loaded:", i),
      (function () {
        const n = document.createElement("style");
        (n.textContent =
          "\n    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');\n\n    /* ===== Layout ===== */\n\n    .shield-widget {\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n    }\n\n    #shield-container {\n    display: flex;\n    border-radius: 8px;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    }\n\n    #shield-container-left {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    }\n\n    #shield-container-title {\n    display: flex;\n    gap: 4px;\n    margin-bottom: 4px;\n    }\n\n    #shield-container-right {\n    display: flex;\n    flex-direction: column;\n    vertical-align: middle;\n    align-items: center;\n    gap: 8px;\n    }\n\n    #shield-container * {\n    font-family: 'Inter', sans-serif !important;\n    }\n\n    .shield-logo {\n    display: none;\n    align-self: center;\n    }\n\n    .shield-text {\n    margin: 0px;\n    font-size: 15px;\n    letter-spacing: -0.01em;\n    word-spacing: -0.01em;\n    flex: 1;\n    }\n\n    #shield-subtitle {\n    font-size: 12px;\n    font-weight: 400;\n    color: #00000080;\n    p {\n    margin: 0;\n    }\n    }\n\n    #shield-price {\n    font-size: 12px;\n    font-weight: 600;\n    }\n\n    .shield-primary {\n    opacity: 1;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n    }\n\n    .shield-secondary {\n    opacity: 0.8;\n    }\n\n    #shipping-protection-amount {\n    font-size: 16px;\n    font-weight: 500;\n    color: #333;\n    margin: 0;\n    padding-bottom: 4px;\n    }\n\n    /* ===== Switch ===== */\n\n    .switch-container {\n    margin-right: auto;\n    }\n\n    .switch {\n    position: relative;\n    display: inline-block;\n    width: 32px;\n    height: 16px;\n    }\n\n    .switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n    }\n\n    .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n    }\n\n    .slider:before {\n    position: absolute;\n    content: '';\n    height: 12px;\n    width: 12px;\n    left: 4.5px;\n    bottom: 2px;\n    background-color: white;\n    -webkit-transition: 0.25s;\n    transition: 0.25s;\n    }\n\n    input:checked + .slider {\n    background-color: black;\n    }\n\n    input:checked + .slider:before {\n    -webkit-transform: translateX(14px);\n    -ms-transform: translateX(14px);\n    transform: translateX(14px);\n    }\n\n    input:focus + .slider {\n    box-shadow: 0 0 1px #003f79;\n    }\n\n    /* Rounded sliders */\n    .slider.round {\n    border-radius: 32px;\n    }\n\n    .slider.round:before {\n    border-radius: 50%;\n    }\n\n    .shield-help-icon {\n    vertical-align: middle;\n    }\n\n    .text-loader {\n    display: inline-block;\n    height: 1em;\n    position: relative;\n    overflow: hidden;\n    background-color: #DDDBDD;\n    width: 14rem;\n    }\n\n    .text-loader::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    transform: translateX(-100%);\n    background-image: linear-gradient(\n        90deg,\n        rgba(255, 255, 255, 0) 0,\n        rgba(255, 255, 255, 0.2) 20%,\n        rgba(255, 255, 255, 0.5) 60%,\n        rgba(255, 255, 255, 0) 100%\n    );\n    animation: shimmer 5s infinite;\n    content: '';\n    }\n\n\n    @keyframes shimmer {\n    100% {\n        transform: translateX(100%);\n    }\n    }\n\n    .loader {\n    width: 24px;\n    height: 24px;\n    border: 3px solid #c7c7c7 !important;\n    border-bottom-color: transparent !important;\n    border-radius: 50%;\n    display: inline-block;\n    box-sizing: border-box;\n    animation: rotation 1s linear infinite;\n    }\n\n    @keyframes rotation {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n    }\n"),
          document.head.appendChild(n);
      })(),
      setTimeout(() => {
        _({ metafields: e });
      }, 200);
  });
})();
